(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/select-draw.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/select-draw.js'); 'use strict';

var selectDraw = function selectDraw(drawNumber) {
  var drawUrlAddOn = svs.tipset.collections.draws.getDrawById(drawNumber).get('urlAddOn');
  svs.tipset.collections.draws.setCurrentDraw(drawUrlAddOn);

  if (svs.tipset.models.play.get('isReduceMode')) {
    svs.tipset.models.systems.clear();
  }

  if (svs.components.marketplace && svs.components.marketplace.accountSelector) {
    var observerHelpers = svs.components.marketplace.accountSelector.helpers.observer;
    svs.components.marketplace.accountSelector.helpers.fetchGames({
      drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
      productId: svs.tipset.collections.draws.getCurrentDraw().get('productId')
    });
    observerHelpers.clearSubscriptions();
  }

  Backbone.history.navigate("/".concat(drawUrlAddOn).concat(location.search), {
    replace: true,
    trigger: true
  });
};

setGlobal('svs.tipset.selectDraw', selectDraw);
 })(window);